module.exports = {"insufficient_coins":"No hay suficientes monedas.","error":"Error al procesar el pedido.","ordered":"Producto pedido."};